<script>
    import {flip} from 'svelte/animate';
    import {getContext, onMount} from "svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";

    export let model_root;
    export let cid;
    export let cname;

    const { close } = getContext('simple-modal');

    let form_send_to;
    let form_items = [];

    let hovering = false;

    onMount(() => {
        loadFormElems().then(formItems => {
            form_items = formItems;
        })
        loadFormConfig().then(formConfig => {
            form_send_to = formConfig[0]["send_to_email"];
        })
    })

    const loadFormConfig = () => {
        return fetch(model_root + 'admin/forms/get_form_config.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadFormElems = () => {
        return fetch(model_root + 'shared/forms/get_form.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = form_items

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        form_items = newTracklist
        hovering = null
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        const start = i;
        event.dataTransfer.setData('text/plain', start);
    }

    const addFormElem = () => {
        form_items = [...form_items,
            {
                type: "TEXT",
                title: "",
                description: "",
                placeholder: "",
                key: (Math.random() + 1).toString(36).substring(7)
            }
        ];
    }

    const removeFormElem = (index) => {
        form_items.splice(index, 1);
        form_items = form_items;
    }

    function deleteEntireFormInDB() {
        return fetch(model_root + 'admin/forms/delete_form.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.text())
            .then(msg => {
                if (msg !== "success") {
                    toasts.error('Fehler bei Vorbereitungen zum Speichern des Formulars', msg, { duration: 10000 });
                }
            });
    }

    async function createFormInDB() {
        if (form_items.length < 1) {
            toasts.error('Keine Formularelemente', "Das Formular muss mindestens ein Feld haben.", {duration: 10000});
            return;
        }
        await deleteEntireFormInDB();
        const data = new FormData();
        data.append("form_cid", cid);
        data.append("form_send_to", "EMAIL");
        data.append("form_send_to_email", form_send_to);

        fetch(model_root + 'admin/forms/create_form.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(async msg => {
                if (msg === "success") {
                    for (let i in form_items) {
                        try {
                            await createFormElemInTB(i);
                        } catch (e) {
                            await deleteEntireFormInDB();
                            return;
                        }
                    }
                    toasts.success('Formular erfolgreich gespeichert', 'Das Fenster schließt sich automatisch.', {duration: 3000});
                    setTimeout(close, 3000);
                } else {
                    toasts.error('Fehler beim Speichern des Formulars', msg, {duration: 10000});
                    await deleteEntireFormInDB();
                }
            });
    }

    function createFormElemInTB(index) {
        const data = new FormData();
        data.append("fe_cid", cid);
        data.append("fe_type", form_items[index].type);
        data.append("fe_title", form_items[index].title);
        data.append("fe_description", form_items[index].description);
        data.append("fe_placeholder", form_items[index].placeholder);
        data.append("fe_sort", index);

        return new Promise((resolve, reject) => {
            fetch(model_root + 'admin/forms/create_form_elem.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(msg => {
                    if (msg === "success") {
                        resolve()
                    } else {
                        toasts.error('Falscher Wert für ein Formularfeld', msg, {duration: 10000});
                        reject();
                    }
                });
        });

    }

</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data} />
</ToastContainer>

<h5 class="mb-1 mt-1 text-muted">FormDesigner</h5>
<h3 class="mb-3">{@html cname}</h3>

<form on:submit|preventDefault
      on:reset|preventDefault>
    <div class="row mb-3">
        <label for="form_emailaddress" class="col-sm-4 col-form-label">Send content to*:</label>
        <div class="col-sm">
            <input type="email" class="form-control" id="form_emailaddress"
                   placeholder="max@mustermann.com"
                   bind:value={form_send_to}>
        </div>
    </div>

    {#if form_items.length > 0}
        <div class="alert alert-light bg-light mb-2">
            <i class="fas fa-sort me-2"></i>Sort the form items by drag and drop.
        </div>
    {/if}

    <hr class="mb-3">

    <div>
        {#each form_items as item, index  (item.key)}
            <div class="row mb-3 px-2 form-list-item"
                 animate:flip="{{duration: 300}}"
                 draggable={true}
                 on:dragstart={event => dragstart(event, index)}
                 on:drop|preventDefault={event => drop(event, index)}
                 ondragover="return false"
                 on:dragenter={() => hovering = index}
                 class:is-active={hovering === index}>
                <div class="border rounded p-3">
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Input type*:</label>
                        <div class="col-sm">
                            <select bind:value={item.type}>
                                <option value="TEXT" selected>Text</option>
                                <option value="EMAIL">Email address</option>
                                <option value="NUMBER">Number</option>
                                <option value="TEXTFIELD">Textfield</option>
                            </select>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Input title*:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" bind:value={item.title}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Input description:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" placeholder="optional" bind:value={item.description}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Input placeholder:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" placeholder="optional" bind:value={item.placeholder}>
                        </div>
                    </div>
                    <hr class="my-3">
                    <div class="row my-1">
                        <div class="col">
                            <button class="btn btn-outline-secondary w-auto py-1 px-2" on:click={() => { removeFormElem(index) }}>
                                <small>
                                    <i class="far fa-trash-alt"></i> Remove input
                                </small>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>

    <button class="btn btn-link text-dark" on:click={addFormElem}>Add input</button>

    <hr class="mb-4">

    <button class="btn btn-primary me-2" on:click={createFormInDB}>Save form</button>
    <button class="btn btn-secondary" on:click={close}>Dismiss changes</button>
</form>

<style>
    .form-list-item.is-active {
        background-color: #bfbfbf;
    }
</style>
